import { Routes, Route } from 'react-router-dom'
import { ModeProvider } from './provider/ModeProvider'
import CollectionForm from './component/CollectionForm'
import Home from './component/Home'
import SimplePaymentForm from './component/SimplePaymentForm'
import UserForm from './component/UserForm'
import FundingForm from './component/FundingForm'
import DeductionForm from './component/DeductionForm'

const Main = () => {
    return (
        <ModeProvider>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collection" element={<CollectionForm />} />
                <Route path="/simple_payment" element={<SimplePaymentForm />} />
                <Route path="/user" element={<UserForm />} />
                <Route path="/funding" element={<FundingForm />} />
                <Route path="/deduction" element={<DeductionForm />} />
            </Routes>
        </ModeProvider>
    )
}
export default Main
